<template>
    <div>
        <div :id="'Div' + nomeFormulario" :name="'Div' + nomeFormulario">
            <form :method="metodoFormulario" :action="linkAction" :id="nomeFormulario" :name="nomeFormulario" @submit.prevent="!visualizar && insereOuAtualiza()" novalidate>
                <div v-if="!edit">
                    <slot name="csrf">

                    </slot>
                </div>
                <input type="hidden" name="id_empresa" :value="cliente.id">

                <fieldset class="ec-form-secao">
                    <legend><b-icon icon="building"></b-icon> Identificação</legend>
                    <div class="form-row">
                        <div class="form-group col-sm-6 col-lg-3">
                            <label for="tipoCadastroPessoa" class="ec-obrigatorio">Tipo de cadastro</label>
                            <select :disabled="edit || visualizar" id="tipoCadastroPessoa" name="tipoCadastroPessoa" class="custom-select" v-model="tipoCadastro">
                                <option value="2">CNPJ</option>
                            </select>
                        </div>
                        <template v-if="cliente.CadastroTipo!=0 && cliente.CadastroTipo==2">
                            <div class="form-group col-sm-6 col-lg-3">
                                <label for="inputCodigoEmpresa" class="ec-obrigatorio">Código da empresa</label>
                                <input :readonly="visualizar" type="text" inputmode="numeric" class="form-control" :class="{ 'is-invalid': errors.codigoempresa }" id="inputCodigoEmpresa" name="inputCodigoEmpresa" placeholder="Ex.: 12" v-model="cliente.codigoempresa">
                                <div class="invalid-feedback" v-if="errors.codigoempresa">{{ errors.codigoempresa[0] }}</div>
                                <small class="form-text">Código da empresa no ERP.</small>
                            </div>
                            <div class="form-group col-sm-6 col-lg-3">
                                <label for="inputOrigem">Origem (CRM)</label>
                                <input :readonly="visualizar" type="text" inputmode="numeric" class="form-control" :class="{ 'is-invalid': errors.origem }" id="inputOrigem" name="inputOrigem" placeholder="Ex.: 9" v-model="cliente.origem">
                                <div class="invalid-feedback" v-if="errors.origem">{{ errors.origem[0] }}</div>
                            </div>
                            <div class="form-group col-sm-6 col-lg-3 ec-campo-switch">
                                <label for="cadastroAtivo">Situação</label>
                                <b-form-checkbox id="cadastroAtivo" v-model="cliente.ativo" name="cadastroAtivo" :value="'Ativo'" :unchecked-value="'Inativo'" :disabled="visualizar" :switch="true">
                                    {{ cliente.ativo=='Ativo' ? 'Ativa' : 'Inativa' }}
                                </b-form-checkbox>
                            </div>
                        </template>
                    </div>
                    <div class="form-row" v-if="cliente.CadastroTipo!=0 && cliente.CadastroTipo==2">
                        <div class="form-group col-lg-6">
                            <label for="inputRazaoSocial" class="ec-obrigatorio">Razão social</label>
                            <input :readonly="visualizar" type="text" class="form-control" :class="{ 'is-invalid': errors.nomecompleto }" id="inputRazaoSocial" name="inputRazaoSocial" placeholder="Nome completo da empresa" v-model="cliente.nomecompleto">
                            <div class="invalid-feedback" v-if="errors.nomecompleto">{{ errors.nomecompleto[0] }}</div>
                        </div>
                        <div class="form-group col-sm-6 col-lg-3">
                            <label for="inputNomeFantasia" class="ec-obrigatorio">Nome reduzido</label>
                            <input :readonly="visualizar" type="text" class="form-control" :class="{ 'is-invalid': errors.nomereduzido }" id="inputNomeFantasia" name="inputNomeFantasia" placeholder="Como aparece nas listas" v-model="cliente.nomereduzido">
                            <div class="invalid-feedback" v-if="errors.nomereduzido">{{ errors.nomereduzido[0] }}</div>
                        </div>
                        <div class="form-group col-sm-6 col-lg-3">
                            <label for="inputCNPJ" class="ec-obrigatorio">CNPJ</label>
                            <the-mask :readonly="visualizar" :masked="true" :mask="['##.###.###/####-##']" inputmode="numeric" class="form-control" :class="{ 'is-invalid': errors.cnpj }" id="inputCNPJ" name="inputCNPJ" placeholder="00.000.000/0000-00" v-model="doc"/>
                            <div class="invalid-feedback" v-if="errors.cnpj">{{ errors.cnpj[0] }}</div>
                        </div>
                    </div>
                </fieldset>

                <template v-if="cliente.CadastroTipo!=0 && cliente.CadastroTipo==2">
                    <fieldset class="ec-form-secao">
                        <legend><b-icon icon="telephone"></b-icon> Contato</legend>
                        <div class="form-row">
                            <div class="form-group col-lg-6">
                                <label for="inputEmail" class="ec-obrigatorio">E-mail</label>
                                <input :readonly="visualizar" type="email" autocomplete="email" class="form-control" :class="{ 'is-invalid': errors.email }" id="inputEmail" name="inputEmail" placeholder="contato@empresa.com.br" v-model="cliente.email">
                                <div class="invalid-feedback" v-if="errors.email">{{ errors.email[0] }}</div>
                            </div>
                            <div class="form-group col-sm-6 col-lg-3">
                                <label for="inputFone">Telefone</label>
                                <the-mask :readonly="visualizar" :masked="true" :mask="['(##)####-####','(##)#####-####']" type="tel" class="form-control" :class="{ 'is-invalid': errors.telefone }" id="inputFone" name="inputFone" placeholder="(00)0000-0000" v-model="cliente.telefone"/>
                                <div class="invalid-feedback" v-if="errors.telefone">{{ errors.telefone[0] }}</div>
                            </div>
                            <div class="form-group col-sm-6 col-lg-3">
                                <label for="inputCelular">Celular</label>
                                <the-mask :readonly="visualizar" :masked="true" :mask="['(##)####-####','(##)#####-####']" type="tel" class="form-control" id="inputCelular" name="inputCelular" placeholder="(00)00000-0000" v-model="cliente.celular"/>
                            </div>
                            <div class="form-group col-lg-6" v-if="users.length>0">
                                <label for="inputRepresentante">Responsável</label>
                                <select :disabled="visualizar" name="inputRepresentante" id="inputRepresentante" class="custom-select" v-model="responsavel_id">
                                    <option :value="0">Selecione o responsável</option>
                                    <option v-for="user in users" :key="user.id" :value="user.id">{{user.nome}}</option>
                                </select>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset class="ec-form-secao">
                        <legend><b-icon icon="geo-alt"></b-icon> Endereço</legend>
                        <div class="form-row">
                            <div class="form-group col-sm-4 col-lg-2">
                                <label for="inputCep">CEP</label>
                                <the-mask :readonly="visualizar" :masked="true" :mask="['#####-###']" inputmode="numeric" class="form-control" id="inputCep" name="inputCep" placeholder="00000-000" v-model="cliente.cep"/>
                            </div>
                            <div class="form-group col-sm-8 col-lg-6">
                                <label for="inputEndereco">Logradouro</label>
                                <input :readonly="visualizar" type="text" class="form-control" id="inputEndereco" name="inputEndereco" placeholder="Rua, avenida..." v-model="cliente.logradouro">
                            </div>
                            <div class="form-group col-4 col-lg-1">
                                <label for="inputNumero">Nº</label>
                                <input :readonly="visualizar" type="text" class="form-control" id="inputNumero" name="inputNumero" placeholder="Nº" v-model="cliente.numero">
                            </div>
                            <div class="form-group col-8 col-lg-3">
                                <label for="inputComplemento">Complemento</label>
                                <input :readonly="visualizar" type="text" class="form-control" id="inputComplemento" name="inputComplemento" placeholder="Sala, bloco..." v-model="cliente.complemento">
                            </div>
                            <div class="form-group col-sm-6 col-lg-4">
                                <label for="inputBairro">Bairro</label>
                                <input :readonly="visualizar" type="text" class="form-control" id="inputBairro" name="inputBairro" placeholder="Bairro ou distrito" v-model="cliente.bairro">
                            </div>
                            <div class="form-group col-sm-6 col-lg-4">
                                <label for="inputCidade">Cidade</label>
                                <input :readonly="visualizar" type="text" class="form-control" id="inputCidade" name="inputCidade" placeholder="Cidade" v-model="cliente.cidade">
                            </div>
                            <div class="form-group col-6 col-lg-2">
                                <label for="inputUF">UF</label>
                                <select :disabled="visualizar" id="inputUF" name="inputUF" class="custom-select" v-model="cliente.estado">
                                    <option value="">Selecione</option>
                                    <option v-for="uf in ufs" :key="uf" :value="uf">{{ uf }}</option>
                                </select>
                            </div>
                            <div class="form-group col-6 col-lg-2">
                                <label for="inputPais">País</label>
                                <input :readonly="visualizar" type="text" class="form-control" id="inputPais" name="inputPais" placeholder="Brasil" v-model="cliente.pais">
                            </div>
                        </div>
                    </fieldset>

                    <fieldset class="ec-form-secao">
                        <legend><b-icon icon="plug"></b-icon> Integrações</legend>
                        <p class="ec-form-secao__descricao">Endereços e chaves de acesso usados na comunicação com o CRM (Rubeus) e o ERP (GVDasa).</p>
                        <div class="form-row">
                            <div class="form-group col-lg-6">
                                <label for="inputUrlApiRubeus">URL da API Rubeus</label>
                                <input :readonly="visualizar" type="url" spellcheck="false" autocomplete="off" class="form-control" :class="{ 'is-invalid': errors.urlapirubeus }" id="inputUrlApiRubeus" name="inputUrlApiRubeus" placeholder="https://..." v-model="cliente.urlapirubeus">
                                <div class="invalid-feedback" v-if="errors.urlapirubeus">{{ errors.urlapirubeus[0] }}</div>
                            </div>
                            <div class="form-group col-lg-6">
                                <label for="inputTokenApiRubeus">Token Rubeus</label>
                                <input :readonly="visualizar" type="text" spellcheck="false" autocomplete="off" class="form-control" :class="{ 'is-invalid': errors.tokenapirubeus }" id="inputTokenApiRubeus" name="inputTokenApiRubeus" placeholder="Token de acesso à API" v-model="cliente.tokenapirubeus">
                                <div class="invalid-feedback" v-if="errors.tokenapirubeus">{{ errors.tokenapirubeus[0] }}</div>
                            </div>
                            <div class="form-group col-lg-6">
                                <label for="inputUrlApiGvdasa">URL da API GVDasa</label>
                                <input :readonly="visualizar" type="url" spellcheck="false" autocomplete="off" class="form-control" :class="{ 'is-invalid': errors.urlapigvdasa }" id="inputUrlApiGvdasa" name="inputUrlApiGvdasa" placeholder="https://..." v-model="cliente.urlapigvdasa">
                                <div class="invalid-feedback" v-if="errors.urlapigvdasa">{{ errors.urlapigvdasa[0] }}</div>
                            </div>
                            <div class="form-group col-lg-6">
                                <label for="inputTokenApiGvdasa">Token GVDasa</label>
                                <input :readonly="visualizar" type="text" spellcheck="false" autocomplete="off" class="form-control" :class="{ 'is-invalid': errors.tokenapigvdasa }" id="inputTokenApiGvdasa" name="inputTokenApiGvdasa" placeholder="Token de acesso à API" v-model="cliente.tokenapigvdasa">
                                <div class="invalid-feedback" v-if="errors.tokenapigvdasa">{{ errors.tokenapigvdasa[0] }}</div>
                            </div>
                        </div>
                    </fieldset>
                </template>

                <div class="ec-form-acoes">
                    <span class="ec-form-legenda" v-if="!visualizar">Campos obrigatórios</span>
                    <a :href="'/'+urlSistema" class="btn btn-outline-primary">{{ visualizar ? 'Voltar' : 'Cancelar' }}</a>
                    <button v-if="!visualizar" type="submit" class="btn btn-primary"><b-icon icon="check2"></b-icon> Salvar</button>
                </div>
            </form>
        </div>
        <modal-component titulo="Mensagem do Sistema" label-btn-fechar="OK" id="MensagemSistema" :url-redirect="'/'+urlSistema+'/'" :sem-padding="true">
            <template v-slot:titulo>
            </template>
            <template v-slot:conteudo>
                <div class="ec-resumo">
                    <p class="ec-resumo__titulo">Empresa</p>
                    <div class="alert alert-success ec-resumo__alerta" role="alert">
                        <b-icon icon="check-circle-fill" aria-hidden="true"></b-icon>
                        <span v-if="edit">Atualizado com sucesso!</span>
                        <span v-else>Cadastrado com sucesso!</span>
                    </div>
                    <dl class="ec-resumo__ficha">
                        <dt>ID</dt>
                        <dd>{{ cliente.id }}</dd>
                        <dt>Nome</dt>
                        <dd>{{ cliente.nomecompleto || '—' }}</dd>
                        <dt>CNPJ</dt>
                        <dd>{{ cliente.cnpj || '—' }}</dd>
                    </dl>
                </div>
            </template>
        </modal-component>
        <modal-component titulo="Exportação CRM" label-btn-fechar="OK" id="ExportacaoCrmMsg" :url-redirect="'/'+urlSistema+'/'" :sem-padding="true">
            <template v-slot:titulo>
                Exportação CRM
            </template>
            <template v-slot:conteudo>
                <div class="ec-resumo">
                    <p class="ec-resumo__titulo">Empresa</p>
                    <div class="alert alert-success ec-resumo__alerta" role="alert">
                        <b-icon icon="check-circle-fill" aria-hidden="true"></b-icon>
                        <span>Empresa exportada para o CRM</span>
                    </div>
                    <dl class="ec-resumo__ficha">
                        <dt>Código</dt>
                        <dd>{{ empresa_exportada_crm.codigoempresa || '—' }}</dd>
                        <dt>ID de exportação</dt>
                        <dd>{{ empresa_exportada_crm.idexportacaocrm || '—' }}</dd>
                        <dt>Nome</dt>
                        <dd>{{ empresa_exportada_crm.nomecompleto || '—' }}</dd>
                    </dl>
                </div>
            </template>
        </modal-component>
        <loading id="SalvandoCompany" titulo="Salvando Empresa, Aguarde..." :sem-padding="true" gif-carregando="/imagens/carregando.gif"></loading>
    </div>
</template>

<script>


export default{

    methods:{
        dissmiss(id){
            this.$bvModal.hide(id);
        },
        novo(id){
            this.user = {}
            this.modoeditar = false
            this.modoexcluir = false
            this.modonovo = true
            this.texto_modal = "Novo"
            this.user.id=id
            // console.log(this.user)
        },
        editar(usuarioSelecionado){
            this.user = usuarioSelecionado;
            this.modoeditar = true
            this.modoexcluir = false
            this.modonovo = false
            this.texto_modal = "Editar"
            // console.log(this.user)
            // console.log(this.user)
        },
        excluir(usuarioSelecionado){
            this.user = usuarioSelecionado;
            this.modoeditar = false
            this.modoexcluir = true
            this.modonovo = false
            this.texto_modal = "Excluir"
            // console.log(this.user)
        },
        checkFormValidity() {
            const valid = this.$refs.form.checkValidity()
            this.nameState = valid
            return valid
        },
        resetModal() {
            this.name = ''
            this.nameState = null
        },
        removerPorId: function (id) {
            var _vm = this; //Adicionando a instância à uma variável, para que possa ser acessada dentro do forEach`
            this.users.forEach(function(el, index) {
                if(el.id === id)
                    _vm.users.splice(index, 1);
            })
        },
        insereOuAtualiza(){
            if(!this.edit){
                this.inserirCompany();
                console.log('insere')
            }else{
                this.atualizaCompany();
                console.log('atualiza')
            }
        },
        inserirCompany(){
            // if(this.modonovo){
                $('#SalvandoCompany').modal('show');
                let url='/api/v1/'+this.urlSistema;
                console.log(url)
                let formData = new FormData();
                formData.append('tipocadastro', this.tipoCadastro)
                formData.append('codigoempresa', (this.cliente.codigoempresa?this.cliente.codigoempresa:''))
                formData.append('nomecompleto', (this.cliente.nomecompleto?this.cliente.nomecompleto:''))
                formData.append('cnpj', (this.cliente.cnpj?this.cliente.cnpj:''))
                formData.append('email', (this.cliente.email?this.cliente.email:''))
                formData.append('telefone', (this.cliente.telefone?this.cliente.telefone:''))
                formData.append('celular', (this.cliente.celular?this.cliente.celular:''))
                formData.append('logradouro', (this.cliente.logradouro?this.cliente.logradouro:''))
                formData.append('numero', (this.cliente.numero?this.cliente.numero:''))
                formData.append('complemento', (this.cliente.complemento?this.cliente.complemento:''))
                formData.append('bairro', (this.cliente.bairro?this.cliente.bairro:''))
                formData.append('cidade', (this.cliente.cidade?this.cliente.cidade:''))
                formData.append('estado', (this.cliente.estado && this.cliente.estado != '0' ?this.cliente.estado:''))
                formData.append('cep', (this.cliente.cep?this.cliente.cep:''))
                formData.append('urlapirubeus', (this.cliente.urlapirubeus?this.cliente.urlapirubeus:''))
                formData.append('tokenapirubeus', (this.cliente.tokenapirubeus?this.cliente.tokenapirubeus:''))
                formData.append('urlapigvdasa', (this.cliente.urlapigvdasa?this.cliente.urlapigvdasa:''))
                formData.append('tokenapigvdasa', (this.cliente.tokenapigvdasa?this.cliente.tokenapigvdasa:''))
                formData.append('ativo',(this.cliente.ativo=='Ativo'?'1':'0'))
                formData.append('origem', (this.cliente.origem?this.cliente.origem:''))
                if(this.tipoCadastro==2){
                    formData.append('nomereduzido', (this.cliente.nomereduzido?this.cliente.nomereduzido:''))
                }else{
                    formData.append('nomereduzido', '')
                }
                formData.append('email',(this.cliente.email?this.cliente.email:''))

                let configuracao = {
                    // method:'post',
                    // headers:{
                    //     // // 'Accept': 'application/json',
                    //     // // 'Authorization': this.$root.token(),
                    // }
                }
                
                axios.post(url,formData,configuracao)
                    .then(response => {
                        this.transacaoStatus = response.status
                        this.cliente = response.data.usuarioNovo;
                        this.errors={};
                        this.cliente.CadastroTipo=2
                        $('#SalvandoCompany').modal('hide');
                        $('#MensagemSistema').modal('show');
                    })
                    .catch(errors => {
                        this.errors = errors.response.data.errors
                        console.log(errors.response)
                    })
            // }
        },
        atualizaCompany(){
            // if(this.modonovo){
                $('#SalvandoCompany').modal('show');
                let url='/api/v1/'+this.urlSistema+'/'+this.cliente.id;
                console.log(url)
                //console.log(this.cliente)                                  
                let formData = new FormData();
                formData.append('_method','patch');
                formData.append('tipocadastro', this.tipoCadastro)
                formData.append('codigoempresa', (this.cliente.codigoempresa?this.cliente.codigoempresa:''))
                formData.append('nomecompleto', (this.cliente.nomecompleto?this.cliente.nomecompleto:''))
                formData.append('cnpj', (this.cliente.cnpj?this.cliente.cnpj:''))
                formData.append('email', (this.cliente.email?this.cliente.email:''))
                formData.append('telefone', (this.cliente.telefone?this.cliente.telefone:''))
                formData.append('celular', (this.cliente.celular?this.cliente.celular:''))
                formData.append('logradouro', (this.cliente.logradouro?this.cliente.logradouro:''))
                formData.append('numero', (this.cliente.numero?this.cliente.numero:''))
                formData.append('complemento', (this.cliente.complemento?this.cliente.complemento:''))
                formData.append('bairro', (this.cliente.bairro?this.cliente.bairro:''))
                formData.append('cidade', (this.cliente.cidade?this.cliente.cidade:''))
                formData.append('estado', (this.cliente.estado && this.cliente.estado != '0' ?this.cliente.estado:''))
                formData.append('cep', (this.cliente.cep?this.cliente.cep:''))
                formData.append('urlapirubeus', (this.cliente.urlapirubeus?this.cliente.urlapirubeus:''))
                formData.append('tokenapirubeus', (this.cliente.tokenapirubeus?this.cliente.tokenapirubeus:''))
                formData.append('urlapigvdasa', (this.cliente.urlapigvdasa?this.cliente.urlapigvdasa:''))
                formData.append('tokenapigvdasa', (this.cliente.tokenapigvdasa?this.cliente.tokenapigvdasa:''))
                formData.append('ativo',(this.cliente.ativo=='Ativo'?'1':'0'))
                formData.append('origem', (this.cliente.origem?this.cliente.origem:''))
                if(this.responsavel_id>0){
                    formData.append('responsavel_id', (this.responsavel_id))
                }
                if(this.tipoCadastro==2){
                    formData.append('nomereduzido', (this.cliente.nomereduzido?this.cliente.nomereduzido:''))
                }else{
                    formData.append('nomereduzido', '')
                }
                formData.append('email',(this.cliente.email?this.cliente.email:''))
                
                let configuracao = {
                    // method:'put',
                    // headers:{
                    // //     'Accept': 'application/json',
                    // //     'Authorization': this.$root.token()
                    // },
                }
                
                axios.post(url, formData,configuracao)
                    .then(response => {
                        // console.log(response)
                        this.transacaoStatus = response.status
                        this.cliente = response.data.usuarioNovo;
                        this.errors={};
                        this.cliente.CadastroTipo=2
                        $('#SalvandoCompany').modal('hide');
                        $('#MensagemSistema').modal('show');
                    })
                    .catch(errors => {
                        this.errors = errors.response.data.errors
                        console.log(errors.response.data)
                        $('#SalvandoCompany').modal('hide');
                    })
            // }
        },
        exportarEmpresaCrm(unidade){
            let url='/api/v1/Companies/Company/CadastroLocaisOferta/'+this.cliente.id;
                
                //console.log(this.cliente)                                  
                
                
            let configuracao = {
                // method:'put',
                // headers:{
                // //     'Accept': 'application/json',
                // //     'Authorization': this.$root.token()
                // },
            }
            
            axios.post(url,configuracao)
                .then(response => {
                    this.empresa_exportada_crm = response.data
                    console.log(this.empresa_exportada_crm)
                    // this.empresa_exportada_crm.id = response.data.resposta_crm.id
                    $('#ExportacaoCrmMsg').modal('show');
                })
                .catch(errors => {
                    this.errors = errors.response.data.errors
                    console.log(errors.response.data)
                })
        },
        excluirUsuarioCliente(id){
            
            if(this.modoexcluir){
                var config = {
                method: 'delete',
                url: '/api/v1/'+this.urlSistema+'/'+id,
                // headers: {
                //         // 'Accept': 'application/json',
                //         // 'Authorization': this.$root.token(),
                //     },
                };
                //executa requisição
                axios(config)
                .then(response => {
                    debugger;
                    // console.log(response.data.usuario)
                    this.$bvModal.hide('modal-prevent-closing')
                    this.$nextTick(() => {
                        window.alert("Usuário de Cliente excluído com sucesso");
                    })
                    this.removerPorId(id)
                })
                .catch(function (error) {
                    console.log(error);
                });
            }
        }
    },
    mounted(){
        // this.$root.atualizaCookie('token');
    },
    created(){

        if(this.pessoa){
            this.cliente = this.pessoa;
            console.log(this.cliente)
            this.users = this.usuarios;
            this.doc=this.pessoa.cnpj;
            
            if(this.pessoa.responsavel_id>0){
                this.responsavel_id=this.pessoa.responsavel_id
            }

            if(this.pessoa.cnpj.length==14){
                this.cliente.CadastroTipo=1
                this.cliente.cnpj = this.pessoa.cnpj;
                this.tipoCadastro=1
            }else if(this.pessoa.cnpj.length==18){
                this.cliente.CadastroTipo=2
                this.cliente.cnpj = this.pessoa.cnpj;
                this.tipoCadastro=2
            }else{
                this.cliente.CadastroTipo=2
                this.tipoCadastro=2
            }
        }else{
            this.cliente.CadastroTipo=2;
            this.tipoCadastro=2;
            this.cliente.estado="0";
        }
    },
    props:{
        urlSistema:{
            type:String,
            required:true
        },
        visualizar:{
            type:Boolean,
            required:true
        },
        nomeFormulario:{
            type:String,
            required:true
        },
        metodoFormulario:{
            type:String,
            required:true
        },
        linkAction:{
            type:String,
            required:true
        },
        pessoa:{
            type:Object,
            required:false
        },
        usuarioAutenticado:{
            type:Object,
            required:false
        },
        usuarios:[],
        edit:{
            type:Boolean,
            required:true
        }
    },
    watch: {
    // whenever question changes, this function will run
        texto_modal(newTexto, oldTtexto) {
            if (newTexto!=oldTtexto) {
                this.texto_modal=newTexto;
            }
        }
        ,tipoCadastro(newTipoCadastro, oldTipoCadastro) {
            if (newTipoCadastro!=oldTipoCadastro) {
                this.cliente.CadastroTipo=newTipoCadastro;
                this.tipoCadastro=newTipoCadastro;
                this.errors={};
            }
        },
        doc(newdoc, olddoc) {
            if (newdoc!=olddoc) {
                this.cliente.cnpj=newdoc;
                this.doc=newdoc;
            }
        },
    },
    data(){
        return{
            ufs:['AC','AL','AM','AP','BA','CE','DF','ES','GO','MA','MG','MS','MT','PA','PB','PE','PI','PR','RJ','RN','RO','RR','RS','SC','SE','SP','TO'],
            transacaoStatus:null,
            modonovo:false,
            modoeditar:false,
            modoexcluir:false,
            Novo:false,
            texto_modal:'',
            nameState: null,
            senhaState:null,
            emailState:null,
            submittedNames: [],
            tipoCadastro:null,
            doc:null,
            cliente:{
                id:null,
                nomecompleto:null,
                nomereduzido:null,
                cnpj:null,
                logradouro:null,
                numero:null,
                complemento:null,
                cep:null,
                pais:null,
                estado:null,
                cidade:null,
                bairro:null,
                site:null,
                email:null,
                telefone:null,
                celular:null,
                codigoempresa:null,
                origem:null,
                /**
                 * cpf = 1
                 * cnpj = 2
                 */
                CadastroTipo:0,
                // link_integracao_gvdasa:null,
                // token_api_gvdasa:null,
                // link_integracao_rubeus:null,
                // token_api_rubeus:null,
                // origem:null,

            },
            user:{
                id:null,
                name:null,
                email:null,
                senha:null,
            },
            responsavel_id:0,
            users:[],
            errors:{},
            empresa_exportada_crm:[{
                id:null,
                codigo:null,
                descricao:null,
                nome:null,
                oridem:null
            }],
        }
    }
}
</script>

<style scoped>
    form{
        text-align: left!important;
    }


    /* resumo do registro no modal de confirmação (rótulo à esquerda, valor à direita; empilha no celular) */
    .ec-resumo {
        text-align: left;
    }

    .ec-resumo__titulo {
        margin: 0;
        padding: .75rem 1.25rem;
        border-bottom: 1px solid #e3e9ed;
        font-size: .78rem;
        font-weight: 700;
        letter-spacing: .04em;
        text-transform: uppercase;
        color: #1c4d5a;
    }

    .ec-resumo__alerta {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: .5rem;
        margin: 0;
        border-width: 0 0 1px;
        border-radius: 0;
        font-weight: 600;
    }

    .ec-resumo__ficha {
        display: grid;
        grid-template-columns: max-content 1fr;
        gap: .45rem 1rem;
        margin: 0;
        padding: 1rem 1.25rem;
    }

    .ec-resumo__ficha dt {
        align-self: center;
        font-size: .68rem;
        font-weight: 700;
        letter-spacing: .04em;
        text-transform: uppercase;
        color: #64767c;
    }

    .ec-resumo__ficha dd {
        margin: 0;
        font-weight: 600;
        overflow-wrap: anywhere;
        font-variant-numeric: tabular-nums;
    }

    @media (max-width: 575.98px) {
        .ec-resumo__ficha { grid-template-columns: 1fr; gap: .1rem; }
        .ec-resumo__ficha dd { margin-bottom: .5rem; }
        .ec-resumo__ficha dd:last-child { margin-bottom: 0; }
    }
</style>
